import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { systemName } from '../../config'
import utils from '../../utils'
import './RiskActionDetails.css'
import { RiskActionStyle } from './RiskActionDetailsStyled'
import { useLocation } from 'react-router-dom/'

const displayResult = value => {
  return value === '1'
    ? 'a/ Rủi ro ở mức không cần xử lý (theo dõi)'
    : value === '2'
    ? 'b/ Rủi ro đã được xử lý'
    : value === '3'
    ? 'c/ Rủi ro đã xảy ra chưa được xử lý'
    : ''
}

const RiskActionDetails4 = ({
  data,
  actionStore,
  isPartOfPdf,
  positionStore,
}) => {
  const { positionList } = positionStore
  useEffect(() => {
    positionStore.getPositionList()
  }, [])
  function convertCodeOrCodesToName(input) {
    const codes = input?.split(',').map(code => code.trim())
    const names = codes?.map(code => {
      const role = positionList?.find(role => role.code === code)
      return role ? role?.name : 'Không tìm thấy chức danh'
    })
    return names?.join(', ')
  }
  const labelBold = { fontWeight: 600 }
  const textValue = { fontStyle: 'italic', fontSize: '14px', marginLeft: 8 }

  const location = useLocation()
  const type = location?.search?.split('=')[1]

  const styleTable = {
    width: '100%',
    backgroundColor: 'white',
    margin: '16px 0 50px',
  }
  const [dataPtt4, setDataPtt4] = useState(null)
  useEffect(() => {
    if (data.length > 0) {
      setDataPtt4(data[0])
    }
  }, [data])
  const nguoi_dang_y_kien = dataPtt4?.nguoi_dang_y_kien
  const cac_y_kien_lien_quan = dataPtt4?.cac_y_kien_lien_quan
  const ban_pc_qtrr_ban_kt_ktnb_vimc = dataPtt4?.ban_pc_qtrr_ban_kt_ktnb_vimc
  const ban_pc_qtrr_ban_kt_ktnb_vimc_ptd =
    dataPtt4?.ban_pc_qtrr_ban_kt_ktnb_vimc?.length > 0
      ? dataPtt4?.ban_pc_qtrr_ban_kt_ktnb_vimc?.[0]
      : null

  const ban_dieu_hanh_hdqt_vimc = dataPtt4?.ban_dieu_hanh_hdqt_vimc
  const ban_dieu_hanh_hdqt_vimc_ptd =
    dataPtt4?.ban_dieu_hanh_hdqt_vimc?.length > 0
      ? dataPtt4?.ban_dieu_hanh_hdqt_vimc?.[0]
      : null

  const don_vi_thuc_hien_xu_ly_rui_ro =
    actionStore?.dataActions?.tier1.length > 0
      ? actionStore?.dataActions?.tier1[0]?.II_xu_ly_rui_ro
          .don_vi_thuc_hien_xu_ly_rui_ro
      : null

  const don_vi_thuc_hien_xu_ly_rui_ro__signed =
    actionStore?.dataActions?.tier1.length > 0
      ? actionStore?.dataActions?.tier1[0]?.II_xu_ly_rui_ro
          .don_vi_thuc_hien_xu_ly_rui_ro__signed
      : null

  const ban_pc_qtrr_ban_kt_ktnb_vimc_signed =
    dataPtt4?.ban_pc_qtrr_ban_kt_ktnb_vimc_signed

  const ban_dieu_hanh_hdqt_vimc_signed =
    dataPtt4?.ban_dieu_hanh_hdqt_vimc_signed
  const ket_qua = dataPtt4?.ket_qua

  const TableHasCheckbox = ({
    label,
    title,
    checked,
    styleCustom,
    isPartOfPdf,
  }) => {
    return (
      <table style={{ margin: '0 ' }}>
        <tbody>
          <tr style={{ backgroundColor: 'white', margin: '0 ' }}>
            <td
              style={{
                border: 'none',
                margin: '0',
                backgroundColor: 'white',
                textAlign: label ? 'none' : 'center',
                fontStyle: styleCustom ? 'italic' : 'normal',
                fontWeight: styleCustom ? 600 : 400,
              }}>
              <div>
                <span style={{ fontWeight: 'bold' }}>{label}</span>
                {isPartOfPdf && label ? (
                  <span
                    style={{
                      fontStyle: 'italic',
                      fontSize: '16px',
                      marginLeft: 8,
                      lineHeight: '1.2',
                    }}>
                    {title}
                  </span>
                ) : (
                  title
                )}
              </div>
            </td>
            <td
              style={{
                border: 'none',
                margin: '0 ',
                backgroundColor: 'white',
                textAlign: 'center',
                display: 'flex',
              }}>
              {checked ? (
                <img
                  id="logo"
                  style={{ width: '30px', height: '24px' }}
                  src={`${window.location.protocol}//${window.location.host}/assets/icons/checkedbox.PNG`}
                />
              ) : (
                <img
                  id="logo"
                  style={{ width: '30px', height: '24px' }}
                  src={`${window.location.protocol}//${window.location.host}/assets/icons/uncheckedbox.PNG`}
                />
              )}
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
  return (
    <RiskActionStyle>
      {type === 'DVPT' ? (
        <h6 style={{ marginTop: 16 }}>VI. KẾT QUẢ KIỂM SOÁT RỦI RO</h6>
      ) : (
        <h6 style={{ marginTop: 16 }}>V. KẾT QUẢ KIỂM SOÁT RỦI RO</h6>
      )}
      {type !== 'CQVP' && (
        <>
          <h6 style={{ display: 'inline-block' }}>1. Kết quả:&nbsp;</h6>
          <span style={{ ...textValue, ...labelBold }}>
            {displayResult(ket_qua)}
          </span>
        </>
      )}
      {type === 'CQVP' && (
        <div>
          <div>
            <TableHasCheckbox
              label={'a/ Rủi ro ở mức không cần xử lý (theo dõi): '}
              checked={dataPtt4?.rui_ro_khong_can_xu_ly}
              isPartOfPdf={isPartOfPdf}
            />
            <div style={{ marginLeft: 20, marginTop: 10, marginBottom: 10 }}>
              <b>Nội dung:</b> {dataPtt4?.rui_ro_khong_can_xu_ly_noi_dung}
            </div>
          </div>
          <div>
            <TableHasCheckbox
              label={'b/ Rủi ro đã được xử lý: '}
              checked={dataPtt4?.rui_ro_duoc_xu_ly}
              isPartOfPdf={isPartOfPdf}
            />
            <div style={{ marginLeft: 20, marginTop: 10, marginBottom: 10 }}>
              <b>Nội dung:</b> {dataPtt4?.rui_ro_duoc_xu_ly_noi_dung}
            </div>
          </div>
          <div>
            <TableHasCheckbox
              label={'c/ Rủi ro đã xảy ra chưa được xử lý: '}
              checked={dataPtt4?.rui_ro_xay_ra_chua_duoc_xu_ly}
              isPartOfPdf={isPartOfPdf}
            />
            <div style={{ marginLeft: 20, marginTop: 10, marginBottom: 10 }}>
              <b>Nội dung:</b>{' '}
              {dataPtt4?.rui_ro_xay_ra_chua_duoc_xu_ly_noi_dung}
            </div>
          </div>
        </div>
      )}
      <h6 style={{ marginTop: 15 }}>2. Các ý kiến liên quan</h6>

      {/* <ActionLabel label="Ý KIẾN:&nbsp;" /> */}
      <div>
        <span>
          {nguoi_dang_y_kien?.length > 0 ? 'Ý kiến của: ' : 'Ý kiến: '}
        </span>
        {nguoi_dang_y_kien?.map((item, index, array) => (
          <span key={index}>
            {utils.getNameInCapitalize(item?.label)}
            {index !== array.length - 1 && ', '}
          </span>
        ))}
      </div>

      <div style={{ ...textValue, ...labelBold }}>
        {/* <RichText htmlText={data[0]?.cac_y_kien_lien_quan || ''}></RichText> */}
        <div
          style={{ ...textValue, ...labelBold }}
          dangerouslySetInnerHTML={{
            __html: `${cac_y_kien_lien_quan || ''}`,
          }}></div>
      </div>
      <>
        <table style={styleTable}>
          <tbody>
            <tr style={{ backgroundColor: 'white' }}>
              <td
                style={{
                  border: 'none',
                  margin: '0 15px 0 10px',
                  backgroundColor: 'white',
                  textAlign: 'center',
                }}>
                <div>
                  <b>ĐƠN VỊ THỰC HIỆN </b>
                </div>
              </td>
              <td
                style={{
                  border: 'none',
                  margin: '0 20px ',
                  backgroundColor: 'white',
                  textAlign: 'center',
                }}>
                <div>
                  {Array.isArray(ban_pc_qtrr_ban_kt_ktnb_vimc) &&
                  ban_pc_qtrr_ban_kt_ktnb_vimc?.some(
                    item => item.department_code === 'BPC&QTRR'
                  ) ? (
                    <b>TGĐ, PTGĐ</b>
                  ) : Array.isArray(ban_pc_qtrr_ban_kt_ktnb_vimc) &&
                    ban_pc_qtrr_ban_kt_ktnb_vimc?.some(
                      item => item.department_code === 'BKTKTNB'
                    ) ? (
                    <b>TGĐ, PTGĐ</b>
                  ) : (
                    <b>TGĐ, PTGĐ</b>
                  )}
                </div>
              </td>
              <td
                style={{
                  border: 'none',
                  margin: '0 10px 0 15px',
                  backgroundColor: 'white',
                  textAlign: 'center',
                }}>
                <div>
                  {Array.isArray(ban_dieu_hanh_hdqt_vimc) &&
                  ban_dieu_hanh_hdqt_vimc?.some(
                    item => item.department_code === 'BDH'
                  ) ? (
                    <b>HĐQT/BKS/TIỂU BAN </b>
                  ) : Array.isArray(ban_dieu_hanh_hdqt_vimc) &&
                    ban_dieu_hanh_hdqt_vimc?.some(
                      item => item.department_code === 'HDQT'
                    ) ? (
                    <b>HĐQT/BKS/TIỂU BAN </b>
                  ) : (
                    <b>HĐQT/BKS/TIỂU BAN </b>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: 'none',
                  margin: '0 10px 0 15px',
                  backgroundColor: 'white',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <div className="textValue">
                  <div style={{ marginBottom: '5px' }}>
                    {don_vi_thuc_hien_xu_ly_rui_ro__signed}
                  </div>
                  {don_vi_thuc_hien_xu_ly_rui_ro
                    ?.filter(el => !el.value.startsWith('CPN'))
                    .map(el => {
                      return (
                        <div
                          // style={{
                          //   fontSize: isPartOfPdf ? '16px' : '13px',
                          // }}
                          key={el.value}>
                          {/* {el.value.slice(0, 3) === 'USR' && (
                          )} */}
                          <div
                            style={{
                              fontSize:
                                el.value.slice(0, 3) === 'USR'
                                  ? '16px'
                                  : '13px',
                            }}>
                            {utils.getNameInCapitalize(el.label)}
                          </div>
                        </div>
                      )
                    })}
                </div>
              </td>
              <td
                style={{
                  border: 'none',
                  margin: '0 20px ',
                  backgroundColor: 'white',
                  textAlign: 'center',
                }}>
                <div className="textValue">
                  <div>
                    {ban_pc_qtrr_ban_kt_ktnb_vimc_signed}
                    <div
                      style={{
                        fontSize: '13px',
                        marginTop: ban_pc_qtrr_ban_kt_ktnb_vimc_signed
                          ? '5px'
                          : '60px',
                      }}>
                      {convertCodeOrCodesToName(
                        ban_pc_qtrr_ban_kt_ktnb_vimc_ptd?.position_name
                      )}
                    </div>

                    <div>
                      {utils.getNameInCapitalize(
                        ban_pc_qtrr_ban_kt_ktnb_vimc_ptd?.full_name
                      )}
                    </div>
                  </div>
                </div>
              </td>
              <td
                style={{
                  border: 'none',
                  margin: '0 10px 0 15px',
                  backgroundColor: 'white',
                  textAlign: 'center',
                }}>
                <div className="textValue">
                  <div>
                    {ban_dieu_hanh_hdqt_vimc_signed}
                    <div
                      style={{
                        fontSize: '13px',
                        marginTop: ban_dieu_hanh_hdqt_vimc_signed
                          ? '5px'
                          : '60px',
                      }}>
                      {convertCodeOrCodesToName(
                        ban_dieu_hanh_hdqt_vimc_ptd?.position_name
                      )}
                    </div>

                    <div>
                      {utils.getNameInCapitalize(
                        ban_dieu_hanh_hdqt_vimc_ptd?.full_name
                      )}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </RiskActionStyle>
  )
}

export default inject(
  'actionStore',
  'positionStore'
)(observer(RiskActionDetails4))
